import PropTypes from 'prop-types';

import { FileDashedIcon, Spinner } from '@utilities';
import { narrativeStatus } from '@helpers/narratives';

import TitleSelectedPrompts from '../TitleSelectedPrompts';

import styles from './_index.module.scss';

const renderNarrativeStatus = ({ createdDatetime, isDraft, narrativeFlowStatus }) => {
  if (isDraft) {
    return (
      <>
        <FileDashedIcon />
        <span>Draft Narrative</span>
      </>
    );
  }
  if (narrativeFlowStatus === narrativeStatus.RUNNING) {
    return (
      <>
        <Spinner className={styles['title-footer-spinner']} />
        <span>Processing...</span>
      </>
    );
  }
  if (createdDatetime) {
    return (
      <>
        <span>Created </span>
        <strong>{createdDatetime}</strong>
      </>
    );
  }
  return null;
};

const TitleFooter = ({
  answers,
  arePromptsLoading = false,
  createdDatetime,
  handleReprompt,
  isDraft,
  isPublicShare,
  isRepromptDisabled,
  narrativeFlowStatus,
  selectedPrompts = [],
}) => {
  return (
    <div className={styles['title-footer-wrapper']}>
      {(!isDraft || selectedPrompts.length > 0 || arePromptsLoading) && (
        <TitleSelectedPrompts
          answers={answers}
          arePromptsLoading={arePromptsLoading}
          handleReprompt={handleReprompt}
          isPublicShare={isPublicShare}
          isRepromptDisabled={isRepromptDisabled}
          selectedPrompts={selectedPrompts}
        />
      )}
      <div className={styles['title-footer-status']}>
        {renderNarrativeStatus({ createdDatetime, isDraft, narrativeFlowStatus })}
      </div>
    </div>
  );
};

TitleFooter.propTypes = {
  answers: PropTypes.object,
  arePromptsLoading: PropTypes.bool,
  createdDatetime: PropTypes.string,
  handleReprompt: PropTypes.func,
  isDraft: PropTypes.bool,
  isPublicShare: PropTypes.bool,
  isRepromptDisabled: PropTypes.bool,
  narrativeFlowStatus: PropTypes.string,
  selectedPrompts: PropTypes.array,
};

export default TitleFooter;
